import React from 'react';
import GiftListCategories from '../../../eventManagement/page/GiftList/components/GiftListContent/GiftListCategories';

const DownloadButtonContainer = ({ component, state, downloadPdfData }) => {
  const title = component?.title || '';
  const subTitle = component?.sub_title || '';
  const buttonText = component?.button_text || '';

  const display_settings = component?.display_settings || {};
  const displaySettings = Array.isArray(display_settings)
    ? display_settings.map((s) => String(s).toLowerCase().trim())
    : [];

  const isMobile = displaySettings.includes('mobile');
  const isTablet = displaySettings.includes('tablet');
  const isDesktop = displaySettings.includes('desktop');

  const allSelected = isMobile && isTablet && isDesktop;
  const noneSelected = !isMobile && !isTablet && !isDesktop;

  let css = '';
  const baseHide = `.gift-list-categories-div { display: none !important; }`;
  const showFlex = `.gift-list-categories-div { display: flex !important; }`;

  const mediaQueries = {
    mobile: `@media (max-width: 767px) { ${showFlex} }`,
    tablet: `@media (min-width: 768px) and (max-width: 1024px) { ${showFlex} }`,
    desktop: `@media (min-width: 1025px) { ${showFlex} }`,
  };

  if (noneSelected) {
    css = baseHide;
  } else if (!allSelected) {
    css = baseHide;
    if (isMobile) css += mediaQueries.mobile;
    if (isTablet) css += mediaQueries.tablet;
    if (isDesktop) css += mediaQueries.desktop;
  }


  const contentData = {
    title,
    subTitle,
    buttonText,
  };


  return (
    <>
      {css && <style>{css}</style>}
      <GiftListCategories 
        contentData={contentData}
        handlePDFDownload={downloadPdfData?.handlePDFDownload}
        selectedTheme={downloadPdfData?.selectedTheme}
        lables={downloadPdfData?.lables}
        selectedTab={downloadPdfData?.selectedTab}
        isDisable={downloadPdfData?.isDisable}
        {...(downloadPdfData?.eventType ? { eventTypeValue: downloadPdfData.eventType } : {})}
        eventChecklistPdfUrl={downloadPdfData?.eventChecklistPdfUrl || ""}
      />
    </>
  );
};

export default DownloadButtonContainer;
